<template>
  <div class="chart-container">
    <Doughnut
      :chart-options="ruleChartOptions"
      :chart-data="ruleChartData"
      :chart-id="chartId"
      :plugins="ruleChartPlugins"
      :width="width"
      :height="height" />
      <!-- {{ color }} -->
  </div>
</template>

<script>

import { Doughnut } from "vue-chartjs/legacy";

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale,);

const basic = { count : 0, color : '#3BC3AB' }
let _buffer = {}

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
} from "chart.js";

export default {
  name: "DoughnutChart",
  components: {
    Doughnut,
  },
  props: {
    color : {
      type: String,
      default: '#3BC3AB',
    },
    count : {
      type: Number,
      default: 0,
    },
    chartId: {
      type: String,
      default: "doughnut-chart",
    },
    width: {
      type: Number,
      default: 200,
    },
    height: {
      type: Number,
      default: 120,
    },
    plugins: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    _count () {
      return this.count
    },
  },
  data: () => ({
    //WMDS Doughnut Chart Data
    ruleChartData: {
      labels: ['Rule'],
      datasets: [
        {
          backgroundColor: [],
          data: [50],
        },
      ],
    },

    //WMDS Doughnut Chart Options
    ruleChartOptions: {
      responsive: true,
      maintainAspectRatio: false,
      borderColor: '',
      backgroundColor: '',
      plugins: { legend: { display: false }, tooltip: { enabled: false }, hover: { enabled: false }, },
      cutout: '65%',
    },

    //WMDS Doughnut Chart Plugin
    ruleChartPlugins: [{
      id: 'text',

      afterRender(chart, args, option) {

        let width = chart.width;
        let height = chart.height;
        let ctx = chart.ctx;

        // ctx.restore();
        ctx.font = "bold 140% pretendard variable";
        // ctx.fillStyle = '#3BC3AB';
        // ctx.fillStyle = _buffer[chart.ctx.canvas.id].color
        ctx.textBaseline = "middle";

        let text = _buffer[chart.ctx.canvas.id].count.toLocaleString('ko-KR');
        let textX = Math.round((width - ctx.measureText(text).width) / 2);
        let textY = height / 2;

        ctx.fillText(text, textX, textY);
        // chart.update()
      }
    }],
  }),

  methods: {

  },

  created() {
    _buffer[this.chartId] = JSON.parse(JSON.stringify(basic))
    _buffer[this.chartId].count = this.count ? this.count : _buffer[this.chartId].count
    _buffer[this.chartId].color = this.color ? this.color : _buffer[this.chartId].color

    this.ruleChartData.datasets[0].backgroundColor = [_buffer[this.chartId].color]

    this.ruleChartOptions.borderColor = _buffer[this.chartId].color
    this.ruleChartOptions.backgroundColor = _buffer[this.chartId].color

    // console.log('_buffer.basic', basic, _buffer[this.chartId], this.chartId, this.count)
  },
  destroyed() { },
  mounted() {

  },

};
</script>

<style>
@media only screen and (min-width : 570px) and (max-width : 1600px) {
  .chart-container {
    font-size: 70%;
  }
}
</style>

